import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { GenericStatus } from '@dealstack/frontend/shared/components/GenericStatus/GenericStatus';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { memo } from 'react';

interface Props {
	className?: string;
	value?: boolean;
	onClick?: () => unknown;
}

const GenericBooleanStatus = ({ className, value = false, onClick }: Props) => {
	const tCommonUi = useTranslationCommonUi();

	return (
		<GenericStatus
			onClick={onClick}
			className={className}
			icon={value ? 'success' : 'remove'}
			colorVariant={value ? 'success' : 'pending'}
		>
			<Text variant="p-md" capitalizeFirst>
				{value ? tCommonUi('boolean.true') : tCommonUi('boolean.false')}
			</Text>
		</GenericStatus>
	);
};
const _GenericBooleanStatusExport = memo(GenericBooleanStatus);

export { _GenericBooleanStatusExport as GenericBooleanStatus };
